import React from 'react';
import {
    ChannelTypeDescriptor as ChannelTypeDescriptorPb,
    ProductStatus,
    Shipping,
    Restriction
} from '../../rpc/admin/products_pb';
import { Supplier } from '../../rpc/admin/suppliers_pb';
import { CategoryDescriptor as CategoryDescriptorPb } from '../../rpc/admin/categories_pb';
import { ManufacturerDescriptor as ManufacturerDescriptorPb} from '../../rpc/admin/manufacturers_pb';
import Option from '../forms/option';

export type ContextProps = { 
    statusOptions: Array<Option<ProductStatus>>,
    supplierOptions: Array<Option<Supplier>>,
    shippingOptions: Array<Option<Shipping>>,
    restrictionOptions: Array<Option<Restriction>>,
    channelTypeDescriptors: Array<ChannelTypeDescriptorPb>,
    categoryDescriptors: Array<CategoryDescriptorPb>,
    manufacturerDescriptors: Array<ManufacturerDescriptorPb>,
};
  
export const ProductContext =  React.createContext<Partial<ContextProps>>({});
